import * as MuiCheckbox from '@mui/material/Checkbox'
import React, { RefObject } from 'react'

export type CheckboxProps = MuiCheckbox.CheckboxProps

export const Checkbox = React.forwardRef(
  (
    { ...props }: CheckboxProps,
    ref:
      | ((instance: HTMLButtonElement | null) => void)
      | RefObject<HTMLButtonElement>
      | null
      | undefined,
  ) => <MuiCheckbox.default ref={ref} {...props} />,
)
